import { getGlobalEventsLogs } from '@cian/events-log';

import { subscribeOnAuthentification, TOPIC_USER } from './subscribeOnAuthentification';
import { IRequestAuthenticationParameters } from './types';

import type { IThunkActionCreator } from '../../store';

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): IThunkActionCreator {
  return dispatch => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      const globalLog = getGlobalEventsLogs();

      dispatch(subscribeOnAuthentification(parameters));

      globalLog.produce(TOPIC_USER, {
        type: 'authenticate',
        value: {
          autoRefresh: false,
          viewData: parameters?.viewData || {},
          source: parameters?.source || null,
        },
      });
    }
  };
}
